import type { I18N } from '@vista-digital/i18n'
import { DateFormat } from '@vista-digital/i18n'
import type { Showtime, Site } from '@vista-digital/ocapi-types/v1'
import { getAttributesByIds } from '@vista-digital/occ-domain'
import type { EcommerceShowtimeProps } from '../models-gtm'

export const mapShowTimeData = (showtime: Showtime, site: Site, i18n: I18N): EcommerceShowtimeProps => ({
    performance_date: new Date(showtime.schedule.businessDate).toLocaleDateString('en-GB'),
    performance_time: i18n.date(new Date(showtime.schedule.startsAt), {
        format: DateFormat.TimeShort,
        ianaTimeZoneName: site.ianaTimeZoneName,
    }),
    showtime_id: showtime.id,
    screen_type: getAttributesByIds(showtime.attributeIds)
        .map(a => a.name.text)
        .join(', '),
    cinema_name: site.name.text,
})
